/**
 * uiStore — estado de UI global (Zustand): janela/modal ativo e sidebar.
 * Substitui os toggles imperativos de classe do legado (classList.add('none') etc.).
 */
import { create } from 'zustand';

export type NoticeKind = 'normal' | 'success' | 'warning' | 'error';

export interface Notice {
  id: string;
  kind: NoticeKind;
  message: string;
}

interface UiState {
  notices: Notice[];
  sidebarOpen: boolean;
  activeModal: string | null;
  pushNotice: (kind: NoticeKind, message: string) => void;
  dismissNotice: (id: string) => void;
  setSidebar: (open: boolean) => void;
  openModal: (id: string) => void;
  closeModal: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  notices: [],
  sidebarOpen: true,
  activeModal: null,
  // Decisão de UX (2026-08-22): o painel não mostra notificações transitórias no canto da tela.
  // Mantemos a API enquanto consumidores antigos migram, mas não acumulamos avisos invisíveis.
  pushNotice: (_kind, _message) => undefined,
  dismissNotice: (_id) => undefined,
  setSidebar: (open) => set({ sidebarOpen: open }),
  openModal: (id) => set({ activeModal: id }),
  closeModal: () => set({ activeModal: null }),
}));
